/* Playmo Generation · visor de fotos ampliadas.
   Dentro de <pg-lightbox>: los elementos [data-zoom] abren la foto en el <dialog> (flechas, Esc y clic fuera para cerrar). */
if (!customElements.get('pg-lightbox')) {
  customElements.define(
    'pg-lightbox',
    class PgLightbox extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-zoom]')).filter((el) => el.dataset.zoom);
        this.dialog = this.querySelector('dialog');
        this.img = this.dialog.querySelector('img');
        this.caption = this.dialog.querySelector('figcaption');
        this.items.forEach((item, index) => item.addEventListener('click', () => this.open(index)));
        this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.querySelectorAll('[data-step]').forEach((btn) =>
          btn.addEventListener('click', () => this.show(this.index + Number(btn.dataset.step)))
        );
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.show(this.index + 1);
          if (event.key === 'ArrowLeft') this.show(this.index - 1);
        });
        this.dialog.addEventListener('close', () => this.items[this.index]?.focus());
        if (this.items.length < 2) this.dialog.querySelectorAll('[data-step]').forEach((btn) => (btn.hidden = true));
      }

      open(index) {
        this.show(index);
        this.dialog.showModal();
      }

      show(index) {
        const count = this.items.length;
        this.index = (index + count) % count;
        const item = this.items[this.index];
        this.img.src = item.dataset.zoom;
        this.img.alt = item.dataset.caption || '';
        this.caption.textContent = item.dataset.caption || '';
      }
    }
  );
}
